var exports = {
  "Q3": "xa15a2ab7--a4fc09--highway",
  "s": "xa15a2ab7--a4fc09--highway_distance",
  "ZE": "xa15a2ab7--a4fc09--highway_link",
  "Kk": "xa15a2ab7--a4fc09--icon",
};

module.exports = exports;
